import { IExtendedTelemetryItem } from "@microsoft/1ds-analytics-web-js";
import analytics from "../../Initialisation";

//Reports a raw event to 1DS.
export const reportRawEvent = (event: any): void => {
    const { baseData, ...content } = event.content;
    const trackedEvent: IExtendedTelemetryItem = {
        baseData: baseData,
        baseType: event.baseType,
        data: content,
        name: event.name,
    };

    analytics.trackEvent(trackedEvent);
};
